import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { APIClient } from '../../utils/APIClient';
import { API_URL } from '../../settings/local_settings';
import { ConfigureEventsStep } from '../client/ad_accounts/ConfigureEventsStep';


class ConfigureEventsModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
        };
        this.handleSave = this.handleSave.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({ currentIndex: 0 });
        }
    }

    handleSave(selectedActions) {
        const { unconfiguredAccounts } = this.props;
        const account = unconfiguredAccounts[this.state.currentIndex];

        new APIClient(`${API_URL}client/ad_account/${account.id}/selected_actions`)
            .call('POST', { selected_actions: selectedActions })
            .then(() => {
                this.advanceToNext();
            })
            .catch(() => {
                this.advanceToNext();
            });
    }

    handleSkip() {
        this.advanceToNext();
    }

    advanceToNext() {
        const { unconfiguredAccounts, onComplete } = this.props;
        const nextIndex = this.state.currentIndex + 1;

        if (nextIndex >= unconfiguredAccounts.length) {
            onComplete();
        } else {
            this.setState({ currentIndex: nextIndex });
        }
    }

    render() {
        const { t, isOpen, toggle, unconfiguredAccounts } = this.props;
        const { currentIndex } = this.state;

        if (!unconfiguredAccounts || unconfiguredAccounts.length === 0) return null;

        const account = unconfiguredAccounts[currentIndex];
        const total = unconfiguredAccounts.length;

        return (
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    {t('events_config_modal.title')}
                    {total > 1 && (
                        <small className="text-muted" style={{ marginLeft: '0.5em', fontSize: '0.75em' }}>
                            ({t('events_config_modal.configuring_step', { current: currentIndex + 1, total })})
                        </small>
                    )}
                </ModalHeader>
                <div className="modal-section" style={{ padding: '0 2em' }}>
                    <p className="text-muted" style={{ marginBottom: '0.5em' }}>
                        {t('events_config_modal.description')}
                    </p>
                    <strong>
                        {t('events_config_modal.account_label', { name: account.name, channel: account.channel })}
                    </strong>
                </div>
                <ConfigureEventsStep
                    key={account.ad_account_db_id}
                    adAccountDbId={account.ad_account_db_id}
                    channel={account.channel}
                    onSave={this.handleSave}
                    onSkip={this.handleSkip}
                />
            </Modal>
        );
    }
}

export const ConfigureEventsModal = withTranslation()(ConfigureEventsModalClass);
export default ConfigureEventsModal;
